/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import nodeLogo from '@/assets/gifs/air-source-heat-pump-grey.gif'
import nodeLogoFixed from '@/assets/gifs/air-source-heat-pump-gray-fixe.gif'

const handleStyleOn = { color: 'green' }
const handleStyleOff = { color: 'red' }

function HeaterNodeDestination({ data, isConnectable }) {
  return (
    <div className="custom-node-wbg robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            {data.heaterState && (
              <img src={nodeLogo} alt="Logo" className="custom-node-robots-logo" />
            )}
            {!data.heaterState && (
              <img src={nodeLogoFixed} alt="Logo" className="custom-node-robots-logo" />
            )}
          </div>
          <div className="text-center">
            <b>Heater</b>
          </div>
          <div className="text-center">
            {data.heaterState && <b style={handleStyleOn}>ON</b>}
            {!data.heaterState && <b style={handleStyleOff}>OFF</b>}
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Left} />
    </div>
  )
}

export default HeaterNodeDestination
